
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Prompt } from "./promptTypes";

/**
 * Fetches featured/popular prompts for homepage display
 */
export const getFeaturedPrompts = async (): Promise<Prompt[]> => {
  try {
    const { data, error } = await supabase
      .from('prompts')
      .select(`
        id, 
        title, 
        description, 
        content,
        likes,
        reviews,
        copies,
        created_at,
        user_id,
        category_id,
        categories(id, name, slug, description, icon, parent_id)
      `)
      .eq('status', 'approved')
      .order('likes', { ascending: false })
      .limit(6);

    if (error) throw error;
    
    if (!data || data.length === 0) {
      console.log('No featured prompts found');
      return [];
    }

    const userIds = data.map(item => item.user_id).filter(Boolean);
    
    let profileMap: Map<string, any> = new Map();
    
    if (userIds.length > 0) {
      const { data: profiles } = await supabase
        .from('profiles')
        .select('id, first_name, last_name')
        .in('id', userIds);
      
      if (profiles) {
        profiles.forEach(profile => {
          profileMap.set(profile.id, profile);
        });
      }
    }

    return data.map(item => {
      const profile = profileMap.get(item.user_id) || {};
      return {
        id: item.id,
        title: item.title,
        description: item.description,
        content: item.content,
        category: item.categories?.name || 'Uncategorized',
        categorySlug: item.categories?.slug,
        likes: item.likes || 0,
        reviews: item.reviews || 0,
        copies: item.copies || 0,
        author: {
          id: item.user_id || 'anonymous',
          name: [profile.first_name, profile.last_name].filter(Boolean).join(' ') || 'Anonymous'
        },
        createdAt: item.created_at
      };
    });
  } catch (error: any) {
    console.error('Error fetching featured prompts:', error);
    toast.error('Failed to load featured prompts');
    return [];
  }
};
